import type { MutableRefObject, ReactNode } from 'react';
import { useRef } from 'react';
import { useOutsideClick } from '../../../hooks/useOutsideClick';
import { createClassName } from '../../../utils/createClassName';
import { FocusTrap } from '../../focusTrap';
import { Menu, Overlay } from './OverLay.styles';

export type OverLayProps = {
  isOverLayOpen?: boolean;
  children?: string | ReactNode;
  testId?: string;
  handleOpenOverlay?: () => void;
  isClosing: boolean;
};
export function OverLay({
  isOverLayOpen = false,
  children,
  testId,
  handleOpenOverlay = () => {},
  isClosing,
}: OverLayProps) {
  const menuRef = useRef(null);
  useOutsideClick(menuRef as unknown as MutableRefObject<HTMLMenuElement>, () => handleOpenOverlay());

  if (!isOverLayOpen) return null;
  return (
    <FocusTrap returnFocus>
      <Overlay aria-modal role="dialog">
        <Menu className={createClassName({ 'is-closing': isClosing })} ref={menuRef} data-testid={testId}>
          {children}
        </Menu>
      </Overlay>
    </FocusTrap>
  );
}
export default OverLay;
